module.exports = __webpack_public_path__ + "img/compact_loader.cf2b40af.jpg";